import { createSlice } from "@reduxjs/toolkit";
import { LanguageID } from "configs";

export interface SystemReducerState {
  language: LanguageID;
  internalServerError?: boolean;
  snackBar: {
    show: boolean;
    message: string;
    type: "success" | "error" | "warning" | "info";
  };
  organizationDialog: boolean;
}

const initialState: SystemReducerState = {
  language: LanguageID.uk,
  internalServerError: false,
  snackBar: {
    show: false,
    message: "",
    type: "info",
  },
  organizationDialog: false,
};

export const systemSlice = createSlice({
  name: "System",
  initialState,
  reducers: {
    showInternalServerError: (state) => {
      state.internalServerError = true;
    },
    reset: (state) => {
      state.internalServerError = undefined;
    },
    showSnackbar: (state, payload) => {
      state.snackBar.show = true;
      state.snackBar.message = payload.payload?.message || "";
      state.snackBar.type = payload.payload?.type || "info";
    },
    hideSnackbar: (state) => {
      state.snackBar.show = false;
      state.snackBar.message = "";
      state.snackBar.type = "info";
    },
    changeLanguage: (state, action) => {
      state.language = action.payload;
    },
    showOrganizationDialog: (state) => {
      state.organizationDialog = true;
    },
    hideOrganizationDialog: (state) => {
      state.organizationDialog = false;
    },
  },
});
